/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Vehicle_Crlv_LabelInputs */

const en_case_section_vehicle_crlv_label = /** @type {(inputs: Case_Section_Vehicle_Crlv_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle registration (CRLV)`)
};

const pt_br2_case_section_vehicle_crlv_label = /** @type {(inputs: Case_Section_Vehicle_Crlv_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento do veículo (CRLV)`)
};

/**
* | output |
* | --- |
* | "Vehicle registration (CRLV)" |
*
* @param {Case_Section_Vehicle_Crlv_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_vehicle_crlv_label = /** @type {((inputs?: Case_Section_Vehicle_Crlv_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Vehicle_Crlv_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_vehicle_crlv_label(inputs)
	return pt_br2_case_section_vehicle_crlv_label(inputs)
});